export default __webpack_public_path__ + "static/media/laptop.af4bc88d.svg";